import { render, staticRenderFns } from "./MeusPontos.vue?vue&type=template&id=ca253b52"
import script from "./MeusPontos.vue?vue&type=script&lang=js"
export * from "./MeusPontos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../go/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports